<template>
  <b-breadcrumb class="justify-content-center" style="background-color: white">
    <b-breadcrumb-item
    v-for="(breadcrumb, idx) in breadcrumbList"
    :key="idx"
    @click="routeTo(idx)">
      <b-icon v-if="breadcrumb.link==='home'" icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
      {{ breadcrumb.name }}
    </b-breadcrumb-item>
    <b-breadcrumb-item active>
        <b-icon v-if="$route.meta.name==='Página Inicial'" icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
        {{this.$route.meta.name}}</b-breadcrumb-item>
  </b-breadcrumb>
</template>

<style scoped>
    a {
        font-size: 1rem;
    }
</style>

<script>
    export default {
        data(){
            return {
                breadcrumbList: [],
            }
        },

        mounted(){
            this.updateList();
        },

        watch: { 
            '$route'(){
                this.updateList()
            }
        },
        methods:{
            routeTo(pRouteTo){
                if ( this.breadcrumbList[pRouteTo].link){
                    this.$router.push({name: this.breadcrumbList[pRouteTo].link})
                }
            },

            updateList(){
                this.breadcrumbList = this.$route.meta.breadcrumb
            }
        }
    }
</script>